import { Format } from 'app/constants/app-constants';
import moment from 'moment';

export const GetURLExtension = (url) => {
  if (!url) return url;
  return url.split(/[#?]/)[0].split('.').pop().trim();
};

export const ConvertObjectAsFormData = (data) => {
  var formData = new FormData();
  for (const item in data) {
    formData.append(item, data[item]);
  }
  return formData;
};

export const hanldeDontHaveAccess = (type) => {
  const dataone = handleDecodeValues();
  let isDontHaveAccess = true;
  if (!dataone?.includes(type)) {
    isDontHaveAccess = true;
  } else {
    isDontHaveAccess = false;
  }
  return isDontHaveAccess;
};

export const hanldeEncodedValues = (type) => {
  let encode = '';
  let tag_array = type.slice();
  for (let i = 0; i < tag_array.length; i++) {
    encode = btoa(tag_array[i]);
    tag_array[i] = encode;
    encode = '';
  }
  return tag_array;
};

export const handleDecodeValues = () => {
  const EncodedData = localStorage.getItem('EncodedValues');
  if (EncodedData) {
    let decode = '';
    let EncodedValues = EncodedData.split(',').slice();
    for (let i = 0; i < EncodedValues.length; i++) {
      decode = atob(EncodedValues[i].toString());
      EncodedValues[i] = decode;
      decode = '';
    }
    return EncodedValues;
  }
};

export const ParseTableDateTime = (date) => {
  if (date) {
    return moment(date).format(Format.DateTime);
  }

  return date;
};

export const ParseTableDate = (date) => {
  if (date) {
    // Render in the viewer's LOCAL (IST) zone, not UTC. Backend stores these as
    // `timestamp` (no tz) at 00:00 and serializes them on the IST server as e.g.
    // "2026-08-04T18:30:00.000Z" (Aug 5 IST midnight). moment.utc() rendered
    // that back in UTC -> the PREVIOUS day (off-by-one). We follow IST, so use
    // local moment. See quick task 260805-d1x. (Sibling ParseTableDateTime
    // already uses local moment.)
    return moment(date).format('DD/MM/YYYY');
  }

  return date;
};

// For calendar-label columns only: start/end/expiry days, invoice dates, DOB.
// The backend runs on UTC and stores a label as its wall clock (00:00, or
// 23:59:59 for points expiry), so it arrives as e.g. "2027-09-30T23:59:59Z".
// ParseTableDate renders that in the viewer's IST zone -> 01/10/2027, a day
// late. The label's day is its UTC day. Real moments (createdAt, upload time,
// last login) must keep using ParseTableDate.
export const ParseTableLabelDate = (date) => {
  if (date) {
    return moment.utc(date).format('DD/MM/YYYY');
  }

  return date;
};

export const checkIfUrl = (value) => {
  if (value?.includes('/') || value?.includes('.') || value?.includes('www')) {
    return true;
  }
  return false;
};

export const urlParser = (url) => {
  if (url?.startsWith('www.')) {
    return 'https://' + url;
  } else if (url?.startsWith('https') || url?.startsWith('http')) {
    return url;
  } else {
    return 'https://www.' + url;
  }
};

export const dataformatChanges = (date) => {
  const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

  return moment(date).format(dateTimeFormat);
};

export const imageSizeValidation = (e) => {
  let file = e.target.files[0];
  return file.size >= 100000;
};

export const newimageSizeValidation = (e, value = null) => {
  if (value) {
    let file = e.target.files[0];
    return file.size >= value;
  } else {
    let file = e.target.files[0];
    return file.size >= 150000;
  }
};
export const showImageUrl = (url) => {
  if (url === 'undefined' || url === '' || url === null) return '';
  if (url?.startsWith('https') || url?.startsWith('http')) {
    return url;
  }

  let newurl = `${process.env.REACT_APP_S3_BUCKET_URL}/${url}`;

  return newurl;
};

export const generateSerialNumber = (currentPage, itemsPerPage, itemIndex) => {
  return (currentPage - 1) * itemsPerPage + itemIndex + 1;
};

export const removeNullValues = (obj) => {
  const newObj = {};

  for (const key in obj) {
    if (obj[key] || obj[key] === 'null') {
      newObj[key] = obj[key];
    }
  }

  return newObj;
};

export function convertTo24HourFormat(time12h) {
  const [time, modifier] = time12h.split(' ');
  let [hours, minutes] = time.split(':');
  hours = parseInt(hours, 10);

  if (modifier === 'PM' && hours !== 12) {
    hours += 12;
  } else if (modifier === 'AM' && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, '0')}:${minutes}`;
}
export function convertTo12HourFormat(time) {
  const [hour, minute] = time.split(':');
  const hourInt = parseInt(hour, 10);
  const ampm = hourInt >= 12 ? 'PM' : 'AM';
  const hour12 = hourInt % 12 || 12;
  return `${hour12}:${minute} ${ampm}`;
}

export const dataformatChangesDateToYear = (date) => {
  const dateTimeFormat = 'DD-MM-YYYY';

  return moment(date).format(dateTimeFormat);
};
export const dataformatChangesYearToDate = (date) => {
  const dateTimeFormat = 'YYYY-MM-DD';

  return moment(date).format(dateTimeFormat);
};
export const dataformatChangesYearToDateandTime = (date) => {
  const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

  return moment(date).format(dateTimeFormat);
};

export const replaceAtPosition = (
  templateBody,
  position,
  newValue,
  regeStringx
) => {
  return templateBody
    .split(
      '/{(InputFiedl|offerType|discountType|purchaseCount|offerAmountType)}/'
    )
    .map((part, index) => {
      if (index === position) {
        return newValue;
      }
      return part;
    })
    .join('');
};
export const formatToIndianRupee = (number) => {
  if (!number) return '';

  // Convert to string and split the number on the decimal point if any
  const [integerPart, decimalPart] = number.toString().split('.');

  // Format the integer part according to Indian numbering system
  const lastThreeDigits = integerPart.slice(-3);
  const otherDigits = integerPart.slice(0, -3);

  const formattedNumber =
    otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
    (otherDigits ? ',' : '') +
    lastThreeDigits;

  // Combine the integer part and the decimal part (if any)
  return decimalPart ? `${formattedNumber}.${decimalPart}` : formattedNumber;
};

// Today's date on the INDIAN calendar, as "YYYY-MM-DD". This is the SINGLE
// source of truth for "what day is it in India right now" — every other
// date-picker bound below is derived from this one call, so the +05:30
// India-time rule is expressed exactly once in this file (D-07: no component,
// and no other function in this file, may re-derive it). Using the Intl
// `Asia/Kolkata` timezone (rather than a hardcoded millisecond offset) is
// self-documenting and needs no `moment-timezone` dependency: India has
// observed no DST since 1945, so a fixed-zone lookup is exact and stable.
//
// The backend decides a campaign's ACTIVE/ENDED status on this same IST
// calendar date (GamificationCampaignService.todayIstDateString). Between
// 00:00 and 05:30 IST the UTC date and the India date differ, so a UTC
// "today" would let the campaign form treat a campaign as still running
// while the listing already shows it Ended. en-CA formats as YYYY-MM-DD —
// the same shape the date inputs hold and the API sends, so callers can
// compare it as a plain string.
//
// A function, not a constant: a dashboard tab left open overnight would
// otherwise keep comparing against the day the tab was loaded.
export const todayIstDate = () =>
  new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });

// The three date-picker bounds below all build on todayIstDate() above so
// the India-date rule is never re-derived. Like todayIstDate(), they are
// FUNCTIONS, called at render time — turning them into module-load constants
// was the original defect this file fixed (D-07 / SC-5).
export const commonMinDate = () => todayIstDate();

export const commonMaxDate = () => {
  const d = new Date(commonMinDate());
  d.setUTCFullYear(d.getUTCFullYear() + 1);
  return d.toISOString().slice(0, 10);
};

export const commonMaxMonth = () => commonMinDate().slice(0, 7);

// Pure UTC month arithmetic on an explicit "YYYY-MM" input — independent of
// the viewer's browser zone and of todayIstDate() above (it never reads
// "now"), so it needs no India-offset handling of its own.
export const istMonthEndDate = (ym) => {
  const [y, m] = ym.split('-');
  return new Date(Date.UTC(+y, +m, 0)).toISOString().slice(0, 10);
};


  export const replaceNAWithEmptyString = (data) => {
    if (typeof data !== 'object' || data === null) return data; // Ensure it's an object
  
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        value === "N/A" || value === "NA" ? "" : value
      ])
    );
  };
  
  

const Parsers = {
  showImageUrl,
  GetURLExtension,
  ConvertObjectAsFormData,
  hanldeDontHaveAccess,
  hanldeEncodedValues,
  handleDecodeValues,
  ParseTableDateTime,
  imageSizeValidation,
  ParseTableDate,
  ParseTableLabelDate,
  generateSerialNumber,
  removeNullValues,
  convertTo24HourFormat,
  replaceNAWithEmptyString
};

export default Parsers;
